import { DEFAULT_GETTERS } from '@/constants'

export default {
  ...DEFAULT_GETTERS,
  contract(state) {
    return state.contract || null
  },
  provinces(state) {
    return state.provinces || []
  },
  provincesOptions(state) {
    return state.provinces.map(province => ({
      label: province.name || province.fullName,
      value: province.code,
      ...province,
    }))
  },
  wards(state) {
    return state.wards || []
  },
  wardsOptions(state) {
    return state.wards.map(ward => ({
      label: ward.name || ward.fullName,
      value: ward.code,
      ...ward,
    }))
  },
}
